import {
  InvalidateOptions,
  InvalidateQueryFilters,
  QueryClient,
} from "@tanstack/react-query";

/**
 * Invalidates all queries whose key array contains at least one string element
 * that includes any of the provided substrings.
 */
export function invalidateQueriesContaining(
  queryClient: QueryClient,
  keys: string[],
  filters?: Omit<InvalidateQueryFilters, "predicate">,
  options?: InvalidateOptions,
): Promise<void> {
  return queryClient.invalidateQueries(
    {
      ...filters,
      predicate: (query) =>
        query.queryKey.find(
          (key) => typeof key === "string" && keys.some((k) => key.includes(k)),
        ) !== undefined,
    },
    options,
  );
}
